import { render, staticRenderFns } from "./LeaseData__comment.vue?vue&type=template&id=854d728a&scoped=true&"
import script from "./LeaseData__comment.vue?vue&type=script&lang=js&"
export * from "./LeaseData__comment.vue?vue&type=script&lang=js&"
import style0 from "./LeaseData__comment.vue?vue&type=style&index=0&id=854d728a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854d728a",
  null
  
)

export default component.exports